import { useState, useEffect } from "react";
import { API } from "./api";
import { Link } from "react-router-dom";

export default function Dashboard() {
  const [c, setC] = useState(0);
  const [p, setP] = useState(0);
  useEffect(() => {
    API.listCategories().then((x) => setC(x.length)).catch(() => {});
    API.listProducts().then((x) => setP(x.length)).catch(() => {});
  }, []);
  return (
    <div data-testid="page-dashboard">
      <h1>Dashboard</h1>
      <div className="stat-cards">
        <Link to="/builder/categories" className="stat" data-testid="stat-categories"><div className="stat-v">{c}</div><div className="stat-l">Categories</div></Link>
        <Link to="/builder/products" className="stat" data-testid="stat-products"><div className="stat-v">{p}</div><div className="stat-l">Products</div></Link>
        <Link to="/builder/media" className="stat" data-testid="stat-media"><div className="stat-v">&#128193;</div><div className="stat-l">Media Manager</div></Link>
      </div>
      <div className="panel hint">
        Build your catalog: create <b>Categories</b>, add <b>Products</b> (with box image,
        screenshots &amp; install ZIP picked from the <b>Media Manager</b>), and the ZIP's
        public URL is what your cart / Joomla update feed serves.
      </div>
    </div>
  );
}
